import gql from 'graphql-tag'

export const policy = gql`
  query policy($language: I18NLocaleCode) {
    policy(locale: $language) {
      documentId
      fullWidthImage {
        title
        description
        img {
          name
          url
        }
      }
      markdownText
      rotatingWords {
        titles {
          title
          description
        }
        content
        buttons {
          ... on ComponentMicroLink {
            label
            url
            style
            image {
              name
              url
            }
          }
        }
      }
    }
  }
`
